export class UpdateCorporateDataEvent {}
